import invokeApi from './../util/apiclient'
export const GET_USER = 'GET_USER'
export const SET_USER = 'SET_USER'

export function getUser (userId) {
    return (dispatch) => {
        return invokeApi('GET', '/users/{userId}/profile', {userId})
            .then((response) => {
                dispatch({ type: GET_USER + '/SUCCESS', result: response.data })
            }).catch((result) => {
                dispatch({ type: GET_USER + '/FAILED' })                
            })
    }
}

export function setUser (user) {
    return (dispatch) => {
        return invokeApi('PUT', '/users/{userId}/profile', {userId: user.userId}, user)
            .then((response) => {
                dispatch({ type: SET_USER + '/SUCCESS', result: response.data })
            }).catch((result) => {
                dispatch({ type: SET_USER + '/FAILED' })                
            })
    }
}